import { createElement } from 'react';
import { b9 as CmsBreadcrumb$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var CmsBreadcrumb = function CmsBreadcrumb(props) {
  return /*#__PURE__*/createElement(CmsBreadcrumb$1, __assign({}, props));
};
CmsBreadcrumb.displayName = 'CmsBreadcrumb';

export { CmsBreadcrumb };
